import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import PaymentLinkExpiryImage from '../../../assets/images/pp_expiry_image.svg';
import { sendAnalytics } from '../../../analytics';
import { ANALYTICS_EVENTS } from '../../../utils/constants';
import classes from './PaymentLinkExpiry.module.scss';

const PaymentLinkExpiry = props => {

  useEffect(() => {
    sendAnalytics({
      vendor: ['mixpanel', 'ga'],
      eventData: {
        event: ANALYTICS_EVENTS.PP_EXPIRED
      }
    })
  }, [])

  return (
    <div className={classes.PaymentLinkExpiryWrapper}>
        <img src={PaymentLinkExpiryImage} alt='PaymentLinkExpiryImage' />
        <h2 className={classes.Message}>No longer accepting Payments</h2>
        <p className={classes.Content}>Looks like this link is no longer active for you to make any new payments. Please reach out to your institute for any queries.</p>
    </div>
  )
};

PaymentLinkExpiry.propTypes = {};

export default PaymentLinkExpiry;